// extracted by mini-css-extract-plugin
export default {"wrapper":"newwork_wrapper__uc6zM","buttonWrapper":"newwork_buttonWrapper__2RlRx","mainButton":"newwork_mainButton__GVSGL"};